export default "__VITE_ASSET__VKOZox1x__"